'use client';

import { c as _c } from "react/compiler-runtime";
import DestinationSlide from "./destination-slide";
import HotelSlide from "./hotel-slide";
import DestinationFromPriceSlide from "./destination-from-price-slide";
import DestinationWithTermSlide from "./destination-with-term-slide";
import HotelWithTermAndPriceSlide from "./hotel-with-term-and-price";
import { ESlideType } from "@/enums/tv-slide";
import Image from "next/image";
export const RenderSlide = t0 => {
  const $ = _c(16);
  const {
    slide
  } = t0;
  switch (slide.type) {
    case ESlideType.Image:
      {
        const t1 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            objectFit: "contain"
          };
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        let t3;
        if ($[1] !== slide.attributes.fileName || $[2] !== t1) {
          t3 = <Image fill={true} src={t1} alt={slide.attributes.fileName} style={t2} />;
          $[1] = slide.attributes.fileName;
          $[2] = t1;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        return t3;
      }
    case ESlideType.Video:
      {
        const t1 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
        let t2;
        if ($[4] !== t1) {
          t2 = <video autoPlay={true} muted={true} src={t1} />;
          $[4] = t1;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case ESlideType.Destination:
      {
        let t1;
        if ($[6] !== slide) {
          t1 = <DestinationSlide slide={slide} />;
          $[6] = slide;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case ESlideType.Hotel:
      {
        let t1;
        if ($[8] !== slide) {
          t1 = <HotelSlide slide={slide} />;
          $[8] = slide;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case ESlideType.DestionationFromPrice:
      {
        let t1;
        if ($[10] !== slide) {
          t1 = <DestinationFromPriceSlide slide={slide} />;
          $[10] = slide;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case ESlideType.DestionationWithTerm:
      {
        let t1;
        if ($[12] !== slide) {
          t1 = <DestinationWithTermSlide slide={slide} />;
          $[12] = slide;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case ESlideType.HotelWithTermAndPrice:
      {
        let t1;
        if ($[14] !== slide) {
          t1 = <HotelWithTermAndPriceSlide slide={slide} />;
          $[14] = slide;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
  }
  return null;
};
export default RenderSlide;